import { useCallback, useReducer } from "react";
import { BundleTypes, generateRandomUniqueId, WIDGET_POSITIONS_OPT, BUNDLE_VISIBILITY_OPT } from "../../constants";
import { ChangeEvents, VolumeConfigInterface, Action } from "../../Types";
import { OffersArr } from "../../OtherPages/constant";

// TODO

export const initialConfigData: VolumeConfigInterface = {
    status: false,
    bundle_type: BundleTypes.VOLUME_DISCOUNT,
    collections: [],
    // design from
    bundles_design: {
        default_cta: true,
        bundle_title_size: 23,
        bundle_title_color: "#000000",
        bundle_title_style: "550 normal",
        product_name_size: 18,
        product_name_color: "#050505",
        product_name_style: "450 normal",
        product_price_size: 15,
        product_price_color: "#050505",
        product_price_style: "350 normal",
        border_color: "#050505",
        border_width: 1,
        border_radius: 8,
        bundle_border_radius: 8,
        background_color: "#F2F4F2",
        hover_effect: "none",
        hover_color: "#000000",
        hover_intensity: 20,
        hover_size: 18,
        elegant_badge_content: "{number}",
        highlighted_offer_tag_size: 12,
        highlighted_offer_tag_color: "#F8F8F8",
        highlighted_offer_tag_style: "550 italic",
        highlighted_price_tag_size: 18,
        highlighted_price_tag_color: "#050505",
        highlighted_price_tag_style: "650 normal",
        total_footer_text_size: 12,
        total_footer_text_color: "#000000",
        total_footer_text_style: "550 normal",
        total_footer_price_text_size: 14,
        total_footer_price_text_color: "#000000",
        total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#ebeaea",
        total_footer_background_style: "450 normal",
        product_background_color: "#f0f0f0",
        product_border_color: "#050505",
        add_to_cart_bg_color: "#303030",
        add_to_cart_hover_bg_color: "#000000",
        add_to_cart_border_radius: 8,
        add_to_cart_border_color: "#FFFFFF",
        add_to_cart_border_width: 0,
        add_to_cart_text_color: "#F5F5F5",
        add_to_cart_text_size: 18,
        add_to_cart_text_style: "750 normal",
        special_text_background_color: "#050505",
        special_text_color: "#ffffff",
        special_text_font_size: 12,
        special_text_style: "550 normal",
        highlighted_offer_tag_background_color: "#053989",
        bundle_widget_bg: "#f4f4f400",
        bundle_widget_font_family: "Custom Store Font",
        product_img_size: "medium",
        product_img_show: "all",
        product_img_border_radius: 10,
        discount_label_background_color: "#000000",
        discount_label_color: "#FFFFFF",
        discount_label_font_size: 14,
        discount_label_style: "550 normal",
        discount_label_primary_color: "#111111",
        discount_label_secondary_color: "#f36a0a",
        discount_label_size: 25,
        special_text_bg_opacity: false,
        free_gift_header_bg_color: "#e3e3e3",
        free_gift_header_color: "#303030",
        free_gift_header_size: 16,
        free_gift_header_style: "650 normal",
        free_gift_bg_color: "#f0f0f0",
        free_gift_text_color: "#303030",
        free_gift_text_size: 14,
        free_gift_text_style: "650 normal",
        free_gift_border: true,
        free_gift_border_width: 0,
        free_gift_border_color: "#441144",
        free_gift_compare_price_color: "#030303",
        free_gift_compare_price_size: 12,
        free_gift_compare_price_style: "350 normal",
        upsell_bg_color: "#f0f0f0",
        upsell_text_color: "#303030",
        upsell_text_size: 14,
        upsell_text_style: "650 normal",
        upsell_price_color: "#050505",
        upsell_price_size: 14,
        upsell_price_style: "650 normal",
        upsell_compare_price_color: "#050505",
        upsell_compare_price_size: 12,
        upsell_compare_price_style: "350 normal",
        quantity_selector_bg_color: "#ffffff00",
        quantity_selector_border_color: "#424242",
        quantity_selector_border_width: 1,
        quantity_selector_border_radius: 4,
        quantity_selector_text_color: "#000000",
        quantity_selector_text_size: 12,
        quantity_selector_text_style: "350 normal",
        variant_selector_text_size: 15,
        variant_selector_text_color: "#383838",
        variant_selector_text_style: "450 normal",
        swatches_select_color: "#000000",
        show_line_around_title_color: "#000000",
        timer_color: "#ff0000",
        timer_text_color: "#000000",
        timer_background_color: "#f0f0f0",
        timer_font_style: "450 normal",
        timer_font_size: 14,
        savings_summary_text_color: "#008060",
        savings_summary_background_color: "#f1f8f5",
        savings_summary_font_size: 16,
        savings_summary_font_style: "450 normal",
        savings_summary_border_radius: 8,
    },
    // content form
    bundle_name: "",
    title: "Buy more, Save more",
    description: "",
    products: [],
    discounted_products: [],
    bundle_product_level: "product",
    hide_native_elements: "",
    add_to_cart_cta_text: "Add to Cart",
    add_to_cart_cta_icon_type: "none",
    add_to_cart_cta_icon_url: "",
    savings_summary: {
        status: false,
        title: "You're saving {saved_amount} on this order",
        icon_type: "none",
        icon_url: "",
        include_free_gift_value: false,
        hide_when_no_savings: true,
        text_align: "center",
    },
    quantity_text: "",
    free_text: "Free",
    start_date: new Date().toISOString(),
    end_date: null,
    show_unit_price: false,
    show_free_gift_popper: false,
    use_compare_at_price: false,
    apply_discount_on_compare_price: false,
    selected_template_volume: "",
    show_variant_selector: true,
    volume_product_selection: "specific",
    bundle_visibility: BUNDLE_VISIBILITY_OPT.ALL_SELECTED_PRODUCT_PAGES,
    show_swatches: false,
    show_option_labels_once: false,
    hide_item_numbers: false,
    use_compact_spacing: false,
    variant_label_position: "above",
    show_line_around_title: true,
    show_unit_price_text: "/unit",
    show_countdown_timer: false,
    countdown_timer_text: "The offer is going to expire soon in {timer} hurry up!",
    countdown_timer_minutes: 5,
    swatchOptions: [],
    swatchesProductsMap: {},
    swatchShape: "circle",
    swatchSize: 18,
    out_of_stock_disable_text: "Oops! Just {itemCount} item(s) are available right now",
    no_stock_text: "Out of stock!",
    offer_name: "",

    // AB Testing
    ab_config: {
        enable: 0,
        exp_id: generateRandomUniqueId(),
        variants: [],
        traffic_allocation_type: "even",
        traffic_percentage: {},
    },

    // target from
    targeting: {
        includeCustomers: "all",
        excludeCustomers: "none",
        includeCustomerData: "",
        excludeCustomerData: "",
        shopifyMarketsTargeting: "all",
        includeLocations: [],
        excludeLocations: [],
        shopifyMarketsTargetingData: [],
        //newKeys
        targetingType: "all",
        customerTagsEnabled: false,
        customerTagType: "include",
        customerTags: "",
        customerSpentEnabled: false,
        customerSpentType: "greater_than",
        customerSpent: "",
        customerCountriesEnabled: false,
        customerCountryType: "include",
        customerCountries: [],
    },

    // Offers
    volume_discounts: [...OffersArr],
    enable_subscription_integration: false,
    default_offer: 0,
    defaultVariantTypes: [],
    // Settings
    general_settings: {
        show_bundle_on_product_page: false,
        show_multiple_bundles_on_product_page: false,
        redirect_after_adding_product_to_cart: "",
        redirect_to_checkout: false,
        show_powered_by_kefi: true,
        max_width: 1000,
        bundle_alignment: "flex-start",
        override_max_width: false,
        override_margin_top: false,
        margin_top: 20,
    },
    bundles_settings: {
        enable_stock_control: false,
        out_of_stock_text: "Out of stock",
        listing_variant_with_image: false,
        work_only_with_widget: false,
        bundle_position: WIDGET_POSITIONS_OPT.ABOVE_CART,
        custom_selector: "",
        custom_css: "",
        custom_js: "",
    },
    show_bundle_widget: "show_everywhere",
    free_shipping: false,
    animation_add_to_cart_btn: "none",
    order_discounts: true,
    product_discounts: true,
    shipping_discounts: true,
    free_gifts: [],
    bundle_products: [],
    upsell_products: [],
};

const useVolumeHook = () => {
    const bundleConfigReducer = useCallback(
        (state: VolumeConfigInterface, action: Action<any>): VolumeConfigInterface => {
            switch (action?.type) {
                case ChangeEvents.initState:
                    return {
                        ...state,
                        ...(action.init as VolumeConfigInterface),
                    };
                default:
                    if (action?.key && action.isComplex) {
                        return {
                            ...state,
                            [action?.key]: {
                                // @ts-expect-error required
                                ...(state[action.key] as object),
                                ...(action.payload as object),
                            },
                        };
                    } else if (action?.key) return { ...state, [action?.key]: action.payload };
                    else return { ...state };
            }
        },
        [],
    );

    const [bundleConfig, dispatchBundleConfig] = useReducer(bundleConfigReducer, initialConfigData);

    return {
        bundleConfig,
        dispatchBundleConfig,
    };
};

export default useVolumeHook;
